<!--
  App shell: header, all pages (one is shown at a time, see appStore.page) and all modals.
  The 3D configurator logic lives in app.ts and src/configurator; components reach it through core/legacy-bridge.ts.
-->
<script setup lang="ts">
import AppHeader from "./components/AppHeader.vue";
import AppLoader from "./components/AppLoader.vue";
import AuthModals from "./components/auth/AuthModals.vue";
import LoginPage from "./components/auth/LoginPage.vue";
import ResetPasswordPage from "./components/auth/ResetPasswordPage.vue";
import ConfigurationsPage from "./components/projects/ConfigurationsPage.vue";
import ProjectModals from "./components/projects/ProjectModals.vue";
import SeriesPage from "./components/series/SeriesPage.vue";
import MaterialGroupModal from "./components/materials/MaterialGroupModal.vue";
import OptionsModal from "./components/options/OptionsModal.vue";
import PlacementModal from "./components/viewport/PlacementModal.vue";
import ViewportPage from "./components/viewport/ViewportPage.vue";
import OrderModal from "./components/summary/OrderModal.vue";
import SummaryPage from "./components/summary/SummaryPage.vue";
</script>

<template>
  
    <!-- Header -->
    <AppHeader />

    <!-- Main -->
    <main class="app__main" v-cloak>

        <AppLoader />

        <!-- Login -->
        <LoginPage />

        <!-- Reset password -->
        <ResetPasswordPage />

        <!-- Configurations -->
        <ConfigurationsPage />


        <!-- Series -->
        <SeriesPage />

        <!-- Summary -->
        <SummaryPage />

        <!-- Viewport -->
        <ViewportPage />
    </main>

    <div class="modals bulma-contextual">

        <PlacementModal />

        <AuthModals />

        <MaterialGroupModal />

        <OrderModal />

        <ProjectModals />

        <OptionsModal />
    </div>

</template>
